import { get } from 'lodash';
import { Properties } from '../polymer/Properties.model';


export class ApplicationStart {
  checked_coo           : boolean;
  checked_tnc           : boolean;
  selected_hdb_property : Properties | undefined;
  has_outstanding_loan  : boolean | undefined;
  isDebarred            : boolean;
  submit_date           : string;
  polymer_stage         : string;
  polymer_status        : string;

  constructor(initial?:any){
    this.checked_coo           = get(initial, 'checked_coo', false);
    this.checked_tnc           = get(initial, 'checked_tnc', false);
    this.selected_hdb_property = get(initial, 'selected_hdb_property', undefined);
    this.has_outstanding_loan  = get(initial, 'has_outstanding_loan', undefined);
    this.isDebarred            = false;
    this.submit_date           = get(initial, 'submit_date', '');
    this.polymer_stage         = get(initial, 'polymer_stage', 'A1')
    this.polymer_status        = get(initial, 'polymer_status', "")
  }

}